import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../shared/services/session.service';



@Component({
  selector: 'app-pdflist',
  templateUrl: './pdflist.component.html',
  styleUrls: ['./pdflist.component.scss']
})
export class PdflistComponent implements OnInit {
  public bloburl: string;
  public mydevice: string = "";
public pdf_list_array=[
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlags/Index/Images/Vi-övar-och-lär.png",
    routerLink:"/pdfprinting/printpdflist1",
    name:"Vi övar och lär"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlags/Index/Images/skriva.png",
    routerLink:"/pdfprinting/printpdflist2",
    name:"Skriva"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlags/Index/Images/skapande.png",
    routerLink:"/pdfprinting/printpdflist3",
    name:"Skapande"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlags/Index/Images/kort.png",
    routerLink:"/pdfprinting/printpdflist4",
    name:"Kort"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlags/Index/Images/blandat.png",
    routerLink:"/pdfprinting/printpdflist5",
    name:"Hemuppgifter m.m."
  }
];
  constructor(private sessionService: SessionService, ) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
  if(isIOS)
  {
    this.mydevice = "ipad";
  }
  else if (android_dev) {
    this.mydevice = "android";

    if (samsung_browser) {
      this.mydevice = this.mydevice + "_samsung";
    }
    else if (chrome_browser) {
      this.mydevice = this.mydevice + "_chrome";

    }
    var body = document.body;
    body.classList.add(this.mydevice);
  }

  }



}
